/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgImportFromBo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-import-from-bo_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-import-from-bo_svg__st0"
      d="M11 5.4V12h2V5.4l1.3 1.3 1.4-1.4L12 1.6 8.3 5.3l1.4 1.4z"
    />
    <path
      className="ico-import-from-bo_svg__st0"
      d="m15.1 8-.2 2c3.5.4 5.1 1.6 5.1 2 0 .5-2.8 2-8 2s-8-1.5-8-2c0-.4 1.6-1.6 5.1-2l-.2-2C5.7 8.4 2 9.7 2 12v6c0 2.7 5.2 4 10 4s10-1.3 10-4v-6c0-2.3-3.7-3.6-6.9-4zM20 18c0 .5-2.8 2-8 2s-8-1.5-8-2v-3.5c1.9 1 5 1.5 8 1.5s6.1-.5 8-1.5V18z"
    />
  </Icon>
);
export { SvgImportFromBo as ImportFromBo };
